enum ScreenIndexes {
  CoachCreateNutritionPlanScreen = 0,
  MacroProfilesEditDayScreen = 1,
  MacroProfilesEditMealAmountScreen = 2,
}

export default ScreenIndexes;
